enum UncertaintyOfMeasurement {
  Percentage = 0,
  Absolute = 1
}

export default UncertaintyOfMeasurement;
